// Unpublished Work © 2023-2024 Deere & Company.

import React from 'react';
import {Themes, LocalizationProvider, ThemeProvider, DateLocalizationProvider, setLicenseKey} from '@deere/isg.component-library';
import PropTypes from 'Utils/prop-type-utils';
const {jddcEnterprise} = Themes;

import Favicon from 'react-favicon';

/**
 * Sets license key needed for MUI X components
 */
setLicenseKey();

function OnlinkThemeProvider(props) {
    const {
        translations,
        children
    } = props;

    return (
        <ThemeProvider theme={jddcEnterprise}>
            <Favicon url={`${window.props.persistentHeaderUrl}/images/favicon-map-ag.ico`}/>
            <LocalizationProvider translations={translations}>
                <DateLocalizationProvider>
                    {children}
                </DateLocalizationProvider>
            </LocalizationProvider>
        </ThemeProvider>
    );
}

OnlinkThemeProvider.propTypes = {
    children: PropTypes.node,
    translations: PropTypes.translations
};

export default OnlinkThemeProvider;
